/// <reference path="../modules/app.module.ts"/>
/// <reference path="../objects/classes/loadinginterceptor.ts" />
/// <reference path="../services/session.service.ts" />

module App {
    class Init {
        constructor(private $rootScope: Interfaces.IAppRootScope, private $timeout: ng.ITimeoutService,
                    private $state: angular.ui.IStateService, private session: App.Interfaces.ISessionService) {
            this.initialize();
            this.catchLoadingEvents($rootScope);
        }

        initialize = () => {
            
        }

        catchLoadingEvents = ($rootScope) => {
            var loadingTimeout: ng.IPromise<any> = null;
            var loadingCounter = 0;
            $rootScope.$on('$stateChangeStart', (e, curr) => {
                loadingCounter++;
                if (loadingTimeout) {
                    this.$timeout.cancel(loadingTimeout);
                }
                loadingTimeout = this.$timeout(() => {
                    $rootScope.loading = true;
                }, Constants.loadingTimeOut);
            });

            $rootScope.$on(Constants.broadcast.loading.show, () => {
                loadingCounter++;
                if (loadingTimeout) {
                    this.$timeout.cancel(loadingTimeout);
                }
                loadingTimeout = this.$timeout(() => {
                    $rootScope.loading = true;
                }, Constants.loadingTimeOut);
            });

            $rootScope.$on('$stateChangeSuccess', (e, curr, prev) => {
                loadingCounter--;
                if (loadingCounter == 0) {
                    if (loadingTimeout) {
                        this.$timeout.cancel(loadingTimeout);
                    }

                    $rootScope.loading = false;
                }
            });

            $rootScope.$on(Constants.broadcast.loading.hide, () => {
                loadingCounter--;
                if (loadingCounter == 0) {
                    if (loadingTimeout) {
                        this.$timeout.cancel(loadingTimeout);
                    }

                    $rootScope.loading = false;
                }
            });
        }
    }

    app.run(['$rootScope', '$timeout', '$state', App.Services.SessionService.serviceId, 
        ($rootScope, $timeout, $state, sessionService) => 
        new Init($rootScope, $timeout, $state, sessionService)]);
    
    class Config {
        constructor($httpProvider: ng.IHttpProvider) {
            $httpProvider.interceptors.push(App.Classes.LoadingInterceptor.Factory);
        }
    }

}